import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import VinWonderTicket from '../models/VinWonderTicket';
import VinWonderTicketItems from '../models/VinWonderTicketItems';
import Urls from './../api/Urls';

export function getVinWonderTicket(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_LIST,
        params: params,
        parser: VinWonderTicketsDataParser,
    }).get();
}

export function getVinWonderTicketDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_DETAIL,
        endpointParams: { id },
        parser: (data) => new VinWonderTicket(data.data),
    }).get();
}

export function createVinWonderTicketDetail(vinWonderTicket) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_CREATE,
        parser: (data) => new VinWonderTicket(data.vinWonderTicket),
    }).post(vinWonderTicket.export());
}

export function updateVinWonderTicketDetail(vinWonderTicket) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_UPDATE,
        parser: (data) => new VinWonderTicket(data.vinWonderTicket),
    }).put(vinWonderTicket.export());
}

export function deleteVinWonderTicketDetail(vinWonderTicket) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_DELETE,
        endpointParams: { id: vinWonderTicket.id }
    }).delete();
}

// Items

export function getListRef(data) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GET_LIST_REF,
        params: data
    }).get();
}

export function getVinWonderTicketItemDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_ITEM_DETAIL,
        endpointParams: { id },
        parser: (data) => new VinWonderTicketItems(data.data),
    }).get();
}

export function createVinWonderTicketItemDetail(vinWonderTicketItem) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_ITEM_CREATE,
        parser: (data) => new VinWonderTicketItems(data.vinWonderTicketItem),
    }).post(vinWonderTicketItem.export());
}

export function updateVinWonderTicketItemDetail(vinWonderTicketItem) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_ITEM_UPDATE,
        parser: (data) => new VinWonderTicketItems(data.vinWonderTicketItem),
    }).put(vinWonderTicketItem.export());
}

export function deleteVinWonderTicketItemDetail(vinWonderTicketItem) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_ITEM_DELETE,
        endpointParams: { id: vinWonderTicketItem.id }
    }).delete();
}


export function createVinWonderTicketTranslate(vinWonderTicket) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_TRANSLATE_CREATE,
    }).post(vinWonderTicket.export(true).translate());
}

export function updateVinWonderTicketTranslate(vinWonderTicket) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_TRANSLATE_UPDATE,
    }).put(vinWonderTicket.export(true).translate());
}

export function deleteVinWonderTicketTranslate(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_TICKET_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const VinWonderTicketsDataParser = (data) => ({
    result: (data.data.result || []).map(item => new VinWonderTicket(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})

// const vinWonderTicketItemsDataParser = (data) => ({
//     result: (data.data.result || []).map(item => new VinWonderTicketItems(item)),
//     pageIndex: data.data.pageIndex,
//     pageSize: data.data.pageSize,
//     totalCount: data.data.totalCount
// })